<template>
	<div @click.stop="openselect" class="mm-select">
		<input @input="searchitem" class="mm-input mm-select-input" type="text" :placeholder="selectedvalue" v-model="keyword" />
		<div class="mm-select-ico"><i class="mm-nav-arrow  el-icon-arrow-down"></i></div>
		<div class="mm-select-option" :class="{'active':active}">
			<div class="mm-sanjiao"></div>
			<div @scroll.passive="getScroll()" class="mm-select-scroll">
				<ul v-if="searchdata.length>0" class="mm-select-ul">
					<li :class="{selected:data.id == hkbank_id}" @click.stop="chooseoption(data.id,data.twname)" v-for="(data,index) in searchdata"
					 :key="index">{{data.code}} {{data.twname}}</li>
				</ul>
				<ul v-else-if="selectdata.length>0 && !keyword" class="mm-select-ul">
					<li :class="{selected:data.id == hkbank_id}" @click.stop="chooseoption(data.id,data.twname)" v-for="(data,index) in selectdata"
					 :key="index">{{data.code}} {{data.twname}}</li>
				</ul>
				<div v-else class="mm-empty">暫無數據</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['form'],
		data() {
			return {
				active: false,
				page: 1,
				selectdata: [],
				hkbank_id: 0,
				selectedvalue: '',
				ajaxing: false,
				enddata: false,
				keyword: '',
				searchdata: [],
			};
		},
		methods: {
			searchitem() {

				this.form.hkbank_id = 0;
				this.form.bankname = this.keyword;
				this.hkbank_id = 0;
				this.active = true;
				this.page = 1;
				this.enddata = false;
				this.post('/api/bank/searchbank', {
					area: 0,
					keyword: this.keyword
				}).then((res) => {
					this.searchdata = res;
				}).catch((err) => {

					console.log(err)
				})
			},
			openselect() {
				var that = this;
				this.active = true;

				function coloseselect() {

					that.active = false;
					that.searchdata = [];

					document.body.removeEventListener('click', coloseselect);
				}
				document.body.addEventListener('click', coloseselect);

			},
			chooseoption(hkbank_id, selectedvalue) {
				this.active = false;
				this.selectedvalue = selectedvalue;
				this.hkbank_id = hkbank_id;
				this.keyword = '';
				this.searchdata = [];
				this.form.hkbank_id = hkbank_id;
				this.form.bankname = selectedvalue;
			},
			init() {
				this.selectedvalue = this.form.bankname==''?this.form.hkbankname:this.form.bankname;
				this.hkbank_id = this.form.hkbank_id;
				this.page = 1;
				this.enddata = false;
				this.post('/api/bank/getbank', {
					area: 0,
					page: 1,

				}).then((res) => {

					this.selectdata = res;

				}).catch((err) => {

					console.log(err)
				})
			},
			appenditems() {

				let nextpage = this.page + 1;
				this.ajaxing = true;
				this.post('/api/bank/getbank', {
					area: 0,
					page: nextpage,
				}).then((res) => {
					this.page = nextpage;
					this.ajaxing = false;
					if (res.length > 0) {
						this.selectdata = this.selectdata.concat(res);

					} else {
						this.enddata = true;
					}

				}).catch((err) => {

					console.log(err)
				})
			},
			getScroll(e) {
				// 滚动条距离底部的距离scrollBottom
				let scrollBottom = event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight;

				if (scrollBottom < 100) {
					if (!this.ajaxing && !this.enddata) {
						this.appenditems();
					}
				}
			},
		},
		created() {
			this.init();
		},
		watch: {
			form: {
				deep: true,
				handler: function(newVal, oldVal) {
					this.selectedvalue = this.form.bankname;
					this.cnbank_id = this.form.cnbank_id;
				}
			},
		}
	};
</script>

<style scoped>
	.mm-select {
		position: relative;
	}

	.mm-select-ico {
		position: absolute;
		right: 10px;
		top: 0px;
		color: #c0c4cc;
		font-size: 14px;
		transition: transform 0.3s;
	}

	.mm-select-input:focus+.mm-select-ico {
		transform: rotate(180deg);
	}

	.mm-input:hover {
		border-color: #c0c4cc;
	}

	.mm-input:focus {
		border-color: #409eff;
		outline: 0;
	}

	.mm-input {
		-webkit-appearance: none;
		background-color: #fff;
		background-image: none;
		border-radius: 4px;
		border: 1px solid #dcdfe6;
		box-sizing: border-box;
		color: #606266;
		display: inline-block;
		font-size: inherit;
		height: 40px;
		line-height: 40px;
		outline: 0;
		padding: 0 15px;
		transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
		width: 100%;
	}

	.mm-select-ul>li {
		font-size: 14px;
		padding: 0 20px;
		position: relative;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		color: #606266;
		height: 34px;
		line-height: 34px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		cursor: pointer;
	}

	.mm-select-ul>li.selected {
		color: #409eff;
		font-weight: 700;
	}

	.mm-select-ul>li:hover {
		background-color: #f5f7fa;
	}

	.mm-select-option {
		position: absolute;
		width: 100%;
		z-index: 1;
		display: none;
		border: 1px solid #e4e7ed;
		border-radius: 4px;
		background-color: #fff;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		padding: 5px 0;
		margin: 5px 0;
		margin-top: 8px;
	}

	.mm-select-option.active {
		display: block;
	}

	.mm-select-scroll {
		min-height: 40px;
		max-height: 200px;
		overflow-x: hidden;
	}

	.mm-select-scroll::-webkit-scrollbar {
		width: 4px;
		height: 4px;
	}

	.mm-select-scroll::-webkit-scrollbar-track {
		background: rgb(239, 239, 239);
		border-radius: 2px;
	}

	.mm-select-scroll::-webkit-scrollbar-thumb {
		background: #bfbfbf;
		border-radius: 10px;
	}

	.mm-select-scroll::-webkit-scrollbar-thumb:hover {
		background: #333;
	}

	.mm-select-scroll::-webkit-scrollbar-corner {
		background: #179a16;
	}

	.mm-sanjiao {
		position: absolute;
		left: 40px;
		top: -11px;
		width: 0px;
		height: 0px;
		overflow: hidden;
		border-width: 6px;
		border-color: transparent transparent #fff transparent;
		border-style: solid solid solid solid;
	}


</style>
